import { CoursesState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const getters = {
    lessonsCategories: (state: CoursesState) => state.lessonsCategories,
    lessons: (state: CoursesState) => state.lessons,
    lesson: (state: CoursesState) => state.lesson,
    comments: (state: CoursesState) => state.comments,
    books: (state: CoursesState) => state.books,
    book: (state: CoursesState) => state.book,
};

const {read} = getStoreAccessors<CoursesState, State>('');

export const readLessonsCategories = read(getters.lessonsCategories);
export const readLessons = read(getters.lessons);
export const readLesson = read(getters.lesson);
export const readComments = read(getters.comments);
export const readBooks = read(getters.books);
export const readBook = read(getters.book);
